import clevertap from 'clevertap-web-sdk';
import { isProduction } from 'utils/envUtils';

import { store } from 'store/store';

export const initializeClevertap = () => {
  clevertap.spa = true;
  clevertap.privacy.push({ optOut: false });
  clevertap.privacy.push({ useIP: false });
  clevertap.init(process.env.REACT_APP_CLEVER_TAP_ACCOUNT_ID);
};

/** CleverTap accepts only scalar event properties (string, number, boolean, date). */
const sanitizeEventParams = (params: Record<string, unknown>): Record<string, string | number | boolean> => {
  const out: Record<string, string | number | boolean> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      out[key] = value.join(',');
    } else if (typeof value === 'object' && value !== null) {
      out[key] = JSON.stringify(value);
    } else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[key] = value;
    }
  });
  return out;
};

export const logAnalyticEvent = (eventName: string, params = {}, hasCommonParam = true) => {
  if (!eventName) {
    if (!isProduction) {
      // eslint-disable-next-line no-console
      console.warn('logAnalyticEvent called with an invalid event name', params);
    }
    return;
  }

  const { rootReducer } = store.getState();

  const { app } = rootReducer;
  const { role, name: teamName, id: teamId } = app.currentTeam;
  const { name, phone, id: merchantId } = app.userDetails ?? {};

  const commonParameters = {
    Phone: phone,
    Role: role,
    'Team Id': teamId,
    'Team Name': teamName,
    'Merchant Id': merchantId,
    'Merchant Name': name
  };
  const sanitizedParams = sanitizeEventParams({
    ...(hasCommonParam && commonParameters),
    ...params
  });
  clevertap.event.push(eventName, sanitizedParams);
  if (!isProduction) {
    // eslint-disable-next-line no-console
    console.log(eventName, commonParameters, params);
  }
};

export const clevertapCreateProfile = profile => {
  clevertap.onUserLogin.push(profile);
};

export const clevertapPushProfile = profile => {
  clevertap.profile.push(profile);
};
